import Images from "@Theme/Images";
import Styles from "./styles.module.scss";
import Icon from "@Atom/Icon";
import Dropdown from "@Atom/DropDown";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import OutlinedSearchBar from "@Atom/OutlinedSearchBar";
import CustomTable from "@Molecule/CustomTable";
import UseOutsideClick from "@Hooks/useOutsideClick";
import ModalWrapper from "@Atom/ModalWrapper";
// import CandidateDetailModal from "@Molecule/_modal/CandidateDetailModal";
import CandidateDetail from "./CandidateDetail";
import ContractViewModal from "@Molecule/_modal/ContractView";
import useQuery from "@Hooks/useQuery";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "@Hooks/useDebounce";
import { Tooltip } from "@mui/material";
import { fileBaseUrl } from "@Config/api";
import convertHtmlToPdf from "@Helpers/convertHtmlToPdf";
import { setContractApproval } from "@Services/contract/contract";

export default function BMContractViewNew({ data, optionsFilter }) {
  const query = useQuery();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const startIndex = 0;
  const endIndex = 1;

  const [positionFilter, setPositionFilter] = useState(query?.get("n") || "");
  const [locationFilter, setLocationFilter] = useState(query?.get("cn") || "");
  const [cityCodeFilter, setCityCodeFilter] = useState(query?.get("cc") || "");
  const [searchName, setSearchName] = useState(query?.get("s") || "");
  const [limit, setLimit] = useState(+query?.get("l") || 10);
  const [page, setPage] = useState(+query?.get("p") || 1);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const boxRef = useRef();
  const boxOutsideClick = UseOutsideClick(boxRef);
  const debounceSearch = useDebounce(searchName, 300);

  const [modalType, setModalType] = useState(null);

  const [trigger, setTrigger] = useState(query?.get("tr") || "");

  useEffect(() => {
    navigate(
      `${pathname}?n=${positionFilter || ""}&cn=${locationFilter || ""}&cc=${
        cityCodeFilter || ""
      }&s=${debounceSearch || ""}&l=${limit || 10}&p=${page || 1}&tr=${
        trigger || ""
      }`
    );
  }, [
    navigate,
    pathname,
    positionFilter,
    locationFilter,
    cityCodeFilter,
    debounceSearch,
    limit,
    page,
    trigger,
  ]);

  useEffect(() => {
    if (boxOutsideClick && selectedCandidate) {
      setSelectedCandidate(null);
    }
  }, [boxOutsideClick, selectedCandidate]);

  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  const [loadingPDF, setLoadingPDF] = useState("");

  const generateContract = useCallback(async (dataResponse) => {
    try {
      setLoadingPDF(dataResponse?.id);
      if (dataResponse?.contractUrl) {
        window.open(fileBaseUrl + dataResponse?.contractUrl);
      } else {
        const convertedHtml = await convertHtmlToPdf(
          dataResponse?.templateContract
        );
        window.open(convertedHtml);
      }

      setLoadingPDF("");
    } catch (error) {
      setLoadingPDF("");
      console.log(error);
    }
  }, []);

  const template = useMemo(() => {
    return {
      data:
        data?.response?.data?.length > 0
          ? data?.response?.data?.map((el, idx) => {
              return {
                id: idx,
                idTemplateContract: el?.ContractDocument?.id || "",
                templateContract: el?.ContractDocument?.template || null,
                contractUrl: el?.ContractDocument?.contractUrl || null,
                position: el?.ExpectedPosition?.name || "-",
                name: el?.name || "-",
                profilePicture: el?.profilePicture || null,
                domicile: el?.domicile || "-",
                address: el?.address || "-",
                email: el?.email || "-",
                phoneNumber: el?.phoneNumber || "-",
              };
            })
          : [],
      columns: [
        {
          name: "name",
          label: "Kandidat",
          minWidth: windowSize[0] > 500 ? "200px" : "150px",
          maxWidth: windowSize[0] > 500 ? "200px" : "150px",
          thClassName: Styles.stickyLeftName,
          tdClassName: Styles.stickyLeftName,
          showRightSeparator: true,
          renderData: (row) => (
            <div className={Styles.profile}>
              <img
                src={
                  row?.profilePicture
                    ? fileBaseUrl + row?.profilePicture
                    : Images?.AVA_DEFAULT
                }
                alt="profilePicture"
              />
              <span>{row?.name}</span>
            </div>
          ),
        },
        {
          name: "templateContract",
          label: "Kontrak",
          align: "center",
          hideOnMobile: true,
          minWidth: "150px",
          thClassName: Styles.stickyLeftContract,
          tdClassName: Styles.stickyLeftContract,
          showRightSeparator: true,
          renderData: (row) => (
            <button
              className={Styles.previewCVButton}
              onClick={() => generateContract(row)}
              disabled={loadingPDF === row?.id}
            >
              <span>{loadingPDF === row?.id ? "Loading..." : "Kontrak"}</span>
              <Icon icon={"report"} size={20} />
            </button>
          ),
        },
        {
          name: "position",
          label: "Posisi",
          minWidth: "180px",
          hideOnMobile: true,
        },
        {
          name: "email",
          label: "Email",
          minWidth: "180px",
          hideOnMobile: true,
        },
        {
          name: "phoneNumber",
          label: "Nomor HP",
          minWidth: "180px",
          hideOnMobile: true,
        },
        {
          name: "domicile",
          label: "Domisili",
          minWidth: "180px",
          hideOnMobile: true,
        },
        {
          name: "address",
          label: "Alamat",
          minWidth: "180px",
          hideOnMobile: true,
        },
        {
          name: "action",
          label: "",
          align: "right",
          showOnMobile: true,
          renderData: (row) => (
            <div
              className={Styles.burgerButton}
              onClick={() => setSelectedCandidate(row)}
            >
              <button>
                <Icon icon="burger-icon" size={32} />
              </button>
            </div>
          ),
        },
        {
          name: "final",
          label: "Final",
          hideOnMobile: true,
          minWidth: windowSize[0] > 768 ? "188px" : "auto",
          align: "center",
          thClassName: Styles.stickyLeft,
          tdClassName: Styles.stickyLeft,
          showRightSeparator: true,
          renderData: (row) => (
            <div className={Styles.actionsWrapper}>
              <button
                className={Styles.rejectButton}
                onClick={() =>
                  setModalType({
                    data: row,
                    type: "confirm-reject",
                  })
                }
                // disabled={row?.invitationTag?.toLowerCase() !== "accepted"}
              >
                <span className={Styles.hideOnMobile}>Reject</span>
                <Icon icon={"cross"} size={20} />
              </button>
              <button
                className={Styles.acceptButton}
                onClick={() =>
                  setModalType({
                    data: row,
                    type: "confirm-approve",
                  })
                }
                // disabled={row?.invitationTag?.toLowerCase() !== "accepted"}
              >
                <span className={Styles.hideOnMobile}>Accept</span>
                <Icon icon={"check"} size={20} />
              </button>
            </div>
          ),
        },
      ],
    };
  }, [data, generateContract, loadingPDF, windowSize]);

  const [errorStatus, setErrorStatus] = useState("");

  const handleSubmit = async (action, remark = "") => {
    try {
      const res = await setContractApproval(
        modalType?.data?.idTemplateContract,
        action,
        remark
      );

      if (action === "Accepted") {
        setModalType({
          type: "success-approve",
        });
      } else {
        setModalType({
          type: "success-reject",
        });
      }
      setTrigger(Math.random());
    } catch (error) {
      setErrorStatus(error?.response?.data?.error);
      console.s(error);
    }
  };

  useEffect(() => {
    const previousPage = page;
    if (+data?.response?.totalData === 1 || +data?.response?.totalData === 0) {
      setPage(1);
    } else {
      const validPage = Math.max(
        1,
        Math.min(previousPage, +data?.response?.totalPage)
      );
      setPage(validPage);
    }
  }, [page, data]);

  return (
    <div className={Styles.body}>
      <div className={Styles.container}>
        <div className={Styles.header}>
          <div className={Styles.left}>
            <span>Daftar Kontrak</span>
            <span>
              Riview kontrak kandidat yang akan diteruskan untuk proses ttd
              kontrak
            </span>
          </div>

          <div className={Styles.right}>
            <div className={Styles.images}>
              <img src={Images.PERMATA_LOGO} alt="" />
            </div>
            <span className={Styles.permataTitle}>
              PT Permata Indo Sejahtera
            </span>
          </div>
        </div>

        <div className={Styles.content}>
          <div className={Styles.top}>
            <div className={Styles.requestDetailsBox}>
              <span className={Styles.requestDetailsTitle}>
                Request Details
              </span>
              <div className={Styles.infoBox}>
                <div>
                  <div className={Styles.icon}>
                    <Icon icon={"people"} size={20} color={"#0A0A0A"} />
                  </div>
                  <span>
                    Total Request : {data?.response?.totalCandidates || "0"}
                  </span>
                </div>

                <div>
                  <div className={Styles.icon}>
                    <Icon icon={"bag-job"} size={20} color={"#0A0A0A"} />
                  </div>
                  <Tooltip
                    title={
                      <span>
                        {data?.response?.position?.length > 0
                          ? data?.response?.position
                              ?.map((item) => item)
                              ?.join(", ")
                          : "-"}
                      </span>
                    }
                  >
                    <span>
                      {data?.response?.position?.slice(startIndex, endIndex)
                        ?.length > 0
                        ? data?.response?.position
                            ?.slice(startIndex, endIndex)
                            .map((item) => item)
                            .join(", ")
                        : "-"}{" "}
                      {`+${
                        data?.response?.position?.length > 1 &&
                        data?.response?.position?.slice(endIndex)?.length
                      }`}
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>

            <div className={Styles.filterBox}>
              <div className={Styles.top}>
                <span>
                  silahkan <span>Approve</span> atau <span>Reject</span> kontrak
                  setelah kamu mereviewnya
                </span>
              </div>

              <div className={Styles.bottom}>
                <Dropdown
                  placeholder={"Semua Lokasi"}
                  options={optionsFilter?.response?.location || []}
                  value={locationFilter}
                  setValue={setLocationFilter}
                  defaultText={"Semua Lokasi"}
                  handleSetDefault={() => {
                    setLocationFilter("");
                    setCityCodeFilter("");
                  }}
                  iconName={"map"}
                  withDefaultSetter
                  withIcon
                  autoClose
                  onClickOption={(obj) => {
                    setCityCodeFilter(obj?.code);
                  }}
                  isApproval
                  maxHeight="250px"
                  overFlowCheck="auto"
                />
                <Dropdown
                  placeholder={"Semua Posisi"}
                  options={optionsFilter?.response?.position?.map((el, idx) => {
                    return {
                      id: idx,
                      name: el,
                    };
                  })}
                  value={positionFilter}
                  setValue={setPositionFilter}
                  defaultText={"Semua Posisi"}
                  handleSetDefault={() => setPositionFilter("")}
                  iconName={"filter"}
                  withDefaultSetter
                  withIcon
                  autoClose
                  maxHeight="250px"
                  overFlowCheck="auto"
                />

                <OutlinedSearchBar
                  placeholder="Cari nama"
                  value={searchName}
                  setValue={setSearchName}
                />
              </div>
            </div>
          </div>

          <div className={Styles.bottom}>
            <CustomTable
              columns={template?.columns}
              data={template?.data || []}
              type={"sticky-left-right"}
              value={+limit}
              setValue={setLimit}
              selectedPage={+page}
              setSelectedPage={setPage}
              totalPage={data?.response?.totalPage || 1}
              totalData={data?.response?.totalData || 0}
              withNumbering
              maxWidthNumbering="50px"
              minHeight="450px"
              isLoadingSkeleton={
                query?.get("n") !== positionFilter ||
                query?.get("cn") !== locationFilter ||
                query?.get("cc") !== cityCodeFilter ||
                query?.get("s") !== searchName ||
                +query?.get("l") !== +limit ||
                +query?.get("p") !== +page ||
                +query?.get("tr") !== +trigger
              }
            />
          </div>
        </div>
      </div>

      <ModalWrapper
        show={selectedCandidate}
        handleClose={() => setSelectedCandidate(null)}
        hideOutsideClick
      >
        {selectedCandidate && (
          <div ref={boxRef}>
            <CandidateDetail
              candidate={selectedCandidate}
              setModalType={setModalType}
              generateContract={generateContract}
              loadingPDF={loadingPDF}
            />
          </div>
        )}
      </ModalWrapper>

      {modalType && (
        <ModalWrapper show={Boolean(modalType)} forceCenter={true}>
          <ContractViewModal
            type={modalType?.type}
            handleCloseModal={() => {
              //   e.stopPropagation();
              setModalType(null);
            }}
            handleSubmit={(action, remark) => handleSubmit(action, remark)}
            errorStatus={errorStatus}
            name={modalType?.data?.name !== "-" ? modalType?.data?.name : ""}
          />
        </ModalWrapper>
      )}
    </div>
  );
}
